import React from "react";
////import { Identity } from "../../components/Identity";
import { PageTopbar } from "../../components/Page/Topbar";
import { PageHeader } from "../../components/Page/Header";
import { AppManagementRentalcost} from "../../app/Management/Rentalcost";

export function RoutesManagementRentalcost({ title, parents, current }) {

    // let identifier = (parents + current).replaceAll('/', '-');

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                tabGroup="management"
                parents={parents}
                current={current}
            />

            <AppManagementRentalcost
                current={current}
                parents={parents}
            />
        </div>
    );
}